const CONFIG = {
  URL: "https://carpha-api.eventqiu.com/api",
  // URL: "https://wcuagm2025-api.eventqiu.com/api",
  TOKEN_SURVEY: "eyJpZF9hZG1pbiI6IjE0IiwidG9rZW4iOiJxcmV1QUVZeHM0dkt0S2xHRkFlZTE0Iiwicm9sZSI6ImFkbWluIn0.NsYHLxXkzZz7jJOUGeC_PPqbYtsQooCJG3oKTnXt1CI",
  TOKEN_VOTING: "eyJpZF9hZG1pbiI6IjE3IiwidG9rZW4iOiJ4MUplSkVkRjh3bkdQTUp6TnV1bTE3Iiwicm9sZSI6ImFkbWluIn0.ZIn0dZudJu8SClBQStZ09wE6A3qBjvJNWOsxGAulG3E"
  // TOKEN_VOTING: "eyJpZF9hZG1pbiI6IjE3IiwidG9rZW4iOiJubUVYNGNFWlFYSXFsN051WExwWjE3Iiwicm9sZSI6ImFkbWluIn0.o_XROej2Y0JazlXxgFqzRO2Kmv2ubQOHG8kx6jIZRTM"
};

export default CONFIG;
